var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      attrs: {
        size: _vm.size,
        clearable: _vm.clearable,
        disabled: _vm.disabled,
        multiple: _vm.multiple,
        placeholder: "请选择",
        "remote-method": _vm.remoteMethod,
        loading: _vm.loading
      },
      on: { change: _vm.selectChange },
      model: {
        value: _vm.id,
        callback: function($$v) {
          _vm.id = $$v
        },
        expression: "id"
      }
    },
    _vm._l(_vm.list, function(item) {
      return _c(
        "el-option",
        { key: item.id, attrs: { label: item.name, value: item.id } },
        [_c("span", [_vm._v(_vm._s(item.name))])]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-97ca65ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97ca65ee","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SourceList.vue
// module id = 616
// module chunks = 14